import React from 'react';
import { PortfolioSpeciesSourceProvider } from 'src/app/portfolio/state/portfolioSpeciesSource';
import PortfolioSiteExplorer from '../portfolio-site-explorer/PortfolioSiteExplorer';

/**
 * The Site Explorer with its species figures read from the prediction grid.
 *
 * The explorer components mounted inside a provider that changes where their species
 * queries point — see portfolioSpeciesSource. The provider outlives the DD-5858
 * cutover because the explorer's own queries still carry projection twins (DD-5856).
 */
const NextPortfolioSiteExplorer = () => (
    <PortfolioSpeciesSourceProvider source='grid'>
        <div className='flex flex-col gap-3' data-testid='next-site-explorer'>
            <PortfolioSiteExplorer />
        </div>
    </PortfolioSpeciesSourceProvider>
);

export default NextPortfolioSiteExplorer;
